import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["BankAccounts"],
});

const bankAccountsApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getBankAccounts: builder.query({
      query: () => `/fees/bank-accounts/school`,
      providesTags: ["BankAccounts"],
    }),
    createBankAccount: builder.mutation({
      query: (values) => ({
        url: "/fees/bank-accounts",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["BankAccounts"],
    }),
    updateBankAccount: builder.mutation({
      query: ({ id, ...values }) => ({
        url: `/fees/bank-accounts/${id}`,
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["BankAccounts"],
    }),
    deleteBankAccount: builder.mutation({
      query: (id) => ({
        url: `/fees/bank-accounts/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BankAccounts"],
    }),
  }),
});

export const {
  useGetBankAccountsQuery,
  useCreateBankAccountMutation,
  useUpdateBankAccountMutation,
  useDeleteBankAccountMutation,
} = bankAccountsApiSlice;
